/** Import dependencies */
import {IMetrics} from '../models/metrics';
export const getClientIP = async() => await(fetch('https://core.pancan.org/api/ip?key=5994766c58613900370b6153').then((data:any) => data.json()).then((data:any) => data.data.ip).catch((error:any) => error));
export const metricsEvent = async(data:IMetrics) => (fetch('https://core.pancan.org/api/metrics/save?key=5994766c58613900370b6153', {
     method: 'POST',
     mode: 'cors',
     headers: {'Content-Type': 'application/json'},
     body: JSON.stringify({ip:await getClientIP(), details: data})
}).then((response:any) => response.json()).then((response:any) => response).catch((error:any) => error));